export const FILTER_CACHE_TTL_MS = 60 * 60 * 1000

export const WAREHOUSE_LEDGER_FILTER_CACHE_KEY = 'bookkeeper:warehouse-ledger-filters-v4'
export const WAREHOUSE_CATALOG_FILTER_CACHE_KEY = 'bookkeeper:warehouse-catalog-filters:v2'

export interface FilterCachePayload<T> {
  savedAt: number
  filters: T
}

export function isFilterCacheValid(savedAt: number, now = Date.now()): boolean {
  return now - savedAt < FILTER_CACHE_TTL_MS
}

export function loadFilterCache<T extends object>(key: string, empty: T): T {
  try {
    const raw = localStorage.getItem(key)
    if (!raw) return empty
    const parsed = JSON.parse(raw) as FilterCachePayload<T>
    if (!parsed?.savedAt || parsed.filters == null) return empty
    if (!isFilterCacheValid(parsed.savedAt)) {
      localStorage.removeItem(key)
      return empty
    }
    return { ...empty, ...parsed.filters }
  } catch {
    localStorage.removeItem(key)
    return empty
  }
}

export function saveFilterCache<T>(key: string, filters: T): void {
  const payload: FilterCachePayload<T> = { savedAt: Date.now(), filters }
  localStorage.setItem(key, JSON.stringify(payload))
}
